import { ORG_CONTACT_PHONE_MAX_LENGTH } from '../constants/orgForm.constants'

/** 7–15 digits after +; first digit after + must be 1–9. */
const ORG_CONTACT_PHONE_E164_REGEX = /^\+[1-9]\d{6,14}$/

/**
 * Normalize user input to E.164 or return null when invalid.
 */
export function normalizeOrgContactPhone(raw: string): string | null {
  const trimmed = raw.trim()
  if (!trimmed) return null

  const withoutSeparators = trimmed.replace(/[\s\-().]/g, '')
  if (!withoutSeparators.startsWith('+')) return null

  const digitsOnly = withoutSeparators.slice(1).replace(/\D/g, '')
  if (!digitsOnly) return null

  const normalized = `+${digitsOnly}`
  if (normalized.length > ORG_CONTACT_PHONE_MAX_LENGTH) return null
  if (!ORG_CONTACT_PHONE_E164_REGEX.test(normalized)) return null
  return normalized
}

export function isValidE164OrgPhone(raw: string): boolean {
  return normalizeOrgContactPhone(raw) !== null
}
